export default {
  'checkfree.manageBillpayWorkFlowTitle': 'Bill Pay Administration',

  'checkfree.noAccess':
    'You do not have access to this service. Please contact your administrator or customer service.',

  'checkfree.ssoLogin.title': 'Bill Pay',
  'checkfree.ssoLogin.billPayManagementButton': 'Manage Bill Pay Users and Accounts',

  'checkfree.tabs.userManagement': 'User Management',
  'checkfree.tabs.accountManagement': 'Account Management',

  'checkfree.accountManagement.setBillPayFeeAccount': 'Set as bill pay fee account',
  'checkfree.accountManagement.billPayFeeAccount': 'Bill Pay Fee Account',
  'checkfree.accountManagement.noRecords': 'No records found',
  'checkfree.accountManagement.createAccountWorkflowTitle': 'Add Bill Pay Account',
  'checkfree.accountManagement.reviewAccountWorkflowTitle': 'Review New Bill Pay Account',
  'checkfree.accountManagement.description': 'Add or edit the account list below.',
  'checkfree.accountManagement.addAccountText': 'Add an additional account below.',
  'checkfree.accountManagement.accountLabel': 'Account Name And Number',
  'checkfree.accountManagement.reviewAccountDescription': 'Review account information below.',
  'checkfree.accountManagement.accountAddedSuccessfully': 'Account Added Successfully!',
  'checkfree.accountManagement.accountAddedModalDescription':
    'Account added successfully to Bill Pay service.',
  'checkfree.accountManagement.modifyBillPayFeeAccountModalTitle': 'Confirm Bill Pay Fee Account',
  'checkfree.accountManagement.modifyBillPayFeeAccountModalDescription':
    'Are you sure you want to change the Bill Pay Fee Account?',
  'checkfree.accountManagement.successModifyingAccount':
    'Bill Pay Fee Account has been modified successfully.',
  'checkfree.accountManagement.deactivateAccountModalTitle': 'Deactivate Bill Pay Account',
  'checkfree.accountManagement.deactivateAccountModalDescription':
    'Are you sure you want to remove the account from Bill Pay service?',
  'checkfree.accountManagement.successDeactivatingAccount':
    'Account has been deactivated successfully.',
  'checkfree.accountManagement.billPayFeeAccountChangeWarning':
    'Update designated Bill Pay Fee account to <%=account%>.',
  'checkfree.accountManagement.gridLabel': 'Checkfree Account Management',

  'checkfree.userManagement.description': 'Add or edit user profile below.',
  'checkfree.userManagement.authorityLevel': 'Authority Level',
  'checkfree.userManagement.userID': 'User ID',
  'checkfree.userManagement.authorizationLevel': 'Authorization Level',
  'checkfree.userManagement.dateOfBirth': 'Date of Birth',
  'checkfree.userManagement.taxId': 'Tax Id',
  'checkfree.userManagement.verifyUserText': 'Review user information below.',
  'checkfree.userManagement.userAddedSuccessfully': 'User Added Successfully!',
  'checkfree.userManagement.userAddedModalDescription':
    'User added successfully to Bill Pay Service.',
  'checkfree.userManagement.userModifiedSuccessfully': 'User Modified Successfully!',
  'checkfree.userManagement.userModifiedModalDescription':
    'User account has been modified successfully.',
  'checkfree.userManagement.userUnregisteredSuccessfully':
    'User has been unregistered from Bill Pay Service successfully',
  'checkfree.userManagement.unregisterConfirmationHeader': 'Unregister User',
  'checkfree.userManagement.unregisterConfirmationMessage':
    'Unregistering a user from the bill payment service will deactivate the user, and it may not be possible to reactivate them in the service later. This action should only be taken if the user will no longer use the service. Are you sure you want to unregister this user?',
  'checkfree.userManagement.userLabel.add': 'Add User',
  'checkfree.userManagement.userLabel.modify': 'Existing User Account',
  'checkfree.userManagement.description.add': 'Add new user account below.',
  'checkfree.userManagement.description.modify': 'Modify User Account',
  'checkfree.userManagement.workflowTitle.add': 'Add New User to Bill Pay Service',
  'checkfree.userManagement.workflowTitle.modify': 'Modify User',
  'checkfree.userManagement.verifyWorkflowTitle.add': 'Review New User',
  'checkfree.userManagement.verifyWorkflowTitle.modify': 'Review Modify User',
  'checkfree.userManagement.gridLabel': 'Checkfree User Management',
  'checkfree.userManagement.actionsNotAvailable': 'Actions not available for this user',

  'checkfree.unregister': 'Unregister',

  'checkfree.validation.minAge18': 'Needs minimum 18 years of age'
};
